export const aiAgent = {
  head: {
    chip: "استقبال بالذكاء الاصطناعي",
    listingLabel: "الإعلان:",
  },
  globalNote: {
    title: "إعدادات على مستوى الحساب",
    body: "تنطبق على <b>جميع مبانيك</b>. يتولى وكيل الذكاء الاصطناعي الرد على كل من يراسلك لأول مرة على <b>رقم واتساب المتصل</b> ولم يصبح <b>عميلاً بعد وليس لديه حجز</b>: يجيب عن استفساراته ويوجّهه نحو إتمام الحجز.",
  },
  perListingNote: {
    title: "يُضبط في كل إعلان",
    body: "يستخدم إصدار الفواتير <b>جهة إصدار الفواتير</b> المرتبطة بكل إعلان، لذلك يتم تفعيله وضبطه في إعدادات كل إعلان (وليس بشكل عام). افتح إعلاناً وادخل إلى «إصدار الفواتير».",
  },
  noEmisor: {
    title: "لا توجد لهذا الإعلان جهة إصدار فواتير",
    body: "لا يمكن تفعيل إصدار الفواتير حتى تربط جهة إصدار بهذا الإعلان في <b>حسابي ← الفوترة الإلكترونية</b>. تُخصَّص كل جهة إصدار لإعلان واحد.",
  },
  master: {
    requiresEmisor: "يتطلب جهة إصدار فواتير",
    on: "مُفعّل",
    off: "مُعطّل",
  },
  cartelQr: {
    title: "لوحة تسجيل الوصول للاستقبال",
    hint: "اطبعها واتركها على المكتب: يمسح الضيف الرمز، ويكتب رقم حجزه، ويكمل تسجيل الوصول من هاتفه. مفيدة عندما لا ترسل القناة كل البيانات.",
    steps: "يمسح الضيف الرمز · يكتب رقم حجزه · يكمل بياناته.",
    download: "تنزيل اللوحة (PDF)",
    downloading: "جارٍ التحضير…",
    downloadError: "تعذّر تحضير اللوحة.",
    copy: "نسخ الرابط",
    copied: "تم نسخ الرابط",
    language: "لغة اللوحة",
    alsoEnglish: "إضافة الإنجليزية تحتها",

    copyManual: "تعذّر النسخ. حدّد الرابط وانسخه يدويًا.",
    popupBlocked: "حجب المتصفح النافذة. انسخ الرابط وافتحه في تبويب جديد.",
    loadError: "تعذّر تحميل الملصق.",
    retry: "إعادة المحاولة",  },
  checkinSchedule: {
    title: "متى يبدأ تسجيل الوصول؟",
    hint: "حدّد موعد إرسال الوكيل رابط تسجيل الوصول إلى النزيل. ينطبق على مستوى الإعلان.",
  },
  avisoCheckin: {
    title: "إرسال بريد عند اكتمال تسجيل الوصول",
    hint: "عند انتهاء المجموعة من التسجيل نرسل ملخص الحجز — صاحب الحجز والمرافقين ووثائقهم — مع استمارة التسجيل الموقّعة كمرفق. مفيد للبوابة أو الاستقبال.",
    enable: "إرسال الإشعار",
    steps: "يُرسل مرة واحدة، عند تسجيل آخر شخص في المجموعة.",
    placeholder: "reception@example.com",
    add: "إضافة بريد",
    remove: "إزالة",
    max: "بحد أقصى {n} عناوين.",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ الإشعار",
    saveError: "تعذّر الحفظ.",
    badEmail: "«{email}» ليس عنوانًا صالحًا.",
    needOne: "أضف بريدًا واحدًا على الأقل لتفعيل الإشعار.",
  },
  field: {
    optional: "(اختياري)",
    yes: "نعم",
    no: "لا",
  },
  variant: {
    nationality: "الجنسية",
    writingStyle: "أسلوب الكتابة",
  },
  robot: {
    title: "ما يعرفه الوكيل",
  },
  pdf: {
    loaded: "تم رفع المستند · سيقرأ الوكيل محتواه",
    remove: "إزالة",
    replace: "استبدال ملف PDF",
    dropTitle: "ارفع ملف PDF أو Word لدليل المبنى",
    dropHint: "PDF أو ‎.docx · بحد أقصى 15 ميجابايت",
  },
  payments: {
    required: "يتطلب ربط منصة تحصيل",
    connect: "ربط منصة تحصيل ←",
  },
  faq: {
    qPlaceholder: "سؤال · مثال: هل يوجد موقف سيارات؟",
    aPlaceholder: "إجابة · مثال: نعم، مجاني عند الباب.",
  },
  list: {
    remove: "حذف",
    add: "إضافة",
  },
  footer: {
    saved: "تم الحفظ",
    save: "حفظ التغييرات",
  },
  wa: {
    online: "متصل الآن",
    caption: "معاينة · تتحدّث حسب إعداداتك",
    defaultName: "استقبال بالذكاء الاصطناعي",
  },
  errors: {
    pdfType: "يجب أن يكون الملف من نوع PDF أو Word ‏(.docx).",
    pdfSize: "حجم الملف يتجاوز 15 ميجابايت.",
    pdfNoText: "تعذّرت قراءة أي نص من المستند (هل هو ملف PDF ممسوح ضوئياً أو فارغ؟). جرّب ملفاً آخر أو استخدم النص الحر.",
    pdfUpload: "تعذّر رفع ملف PDF.",
    pdfRemove: "تعذّرت إزالة ملف PDF.",
    loadConfig: "تعذّر تحميل الإعدادات.",
    saveConfig: "تعذّر الحفظ. حاول مرة أخرى.",
  },
  features: {
    general: {
      title: "الإعدادات العامة",
      subtitle: "حدّد هوية الوكيل وأسلوبه. هذا إعداد على مستوى الحساب: ينطبق على جميع مبانيك.",
      sections: {
        identity: {
          label: "هوية الوكيل",
          hint: "كيف يُعرّف عن نفسه وبأي أسلوب يردّ.",
        },
      },
      fields: {
        agentName: {
          label: "اسم الوكيل",
          placeholder: "مثال: Sofía، استقبال Loft Ámbar…",
        },
        persona: {
          label: "الشخصية",
          options: {
            amigable: "ودودة وقريبة",
            profesional: "احترافية وحاسمة",
            eficiente: "مباشرة وفعّالة",
            entusiasta: "متحمّسة ودافئة",
            sereno: "هادئة ومطمئنة",
          },
        },
        tone: {
          label: "نبرة الردود",
          options: {
            cercano: "قريبة",
            cordial: "لبقة",
            formal: "رسمية",
            profesional: "احترافية",
          },
        },
        responseLength: {
          label: "طول الردود",
          options: {
            brief: "مختصرة (جملة أو جملتان)",
            balanced: "متوازنة",
            detailed: "مفصّلة",
          },
        },
        useEmojis: {
          label: "استخدام الإيموجي",
        },
        language: {
          label: "اللغة الرئيسية",
          options: {
            auto: "تلقائي (حسب النزيل)",
            es: "الإسبانية",
            en: "الإنجليزية",
            fr: "الفرنسية",
            de: "الألمانية",
            pt: "البرتغالية",
            it: "الإيطالية",
          },
        },
        spanishVariant: {
          label: "أسلوب الكتابة (بالإسبانية)",
        },
        signature: {
          label: "توقيع الختام",
          placeholder: "مثال: — فريق Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "قاعدة المعرفة",
      subtitle: "كل ما يحتاج وكيل الذكاء الاصطناعي معرفته لخدمة نزلائك بدقة.",
      enableLabel: "يستخدم الوكيل قاعدة المعرفة هذه",
      sections: {
        knowledge: {
          label: "معلومات المبنى",
          hint: "اختر كيف تقدّم المعلومات التي سيستخدمها الوكيل.",
        },
        behavior: {
          label: "السلوك والحدود",
          hint: "حدّد قواعد الوكيل ومتى يطلب مساعدة بشرية.",
        },
      },
      fields: {
        kbMode: {
          label: "كيف تريد تقديم المعلومات؟",
          options: {
            form: "نماذج",
            text: "نص حر",
            pdf: "رفع مستند",
          },
        },
        propertyType: {
          label: "نوع المبنى",
          options: {
            apartment: "شقة",
            house: "منزل",
            villa: "فيلا",
            loft: "لوفت",
            room: "غرفة",
            cabin: "كوخ",
            hotel: "فندق",
            hostel: "بيت شباب",
          },
        },
        kbText: {
          label: "معلومات المبنى",
          placeholder: "اكتب أو الصق هنا كل ما يجب أن يعرفه الوكيل: شبكة الواي فاي وكلمة المرور، موقف السيارات، الأجهزة، التكييف، القواعد، توصيات المنطقة…",
          hint: "سيستخدم الوكيل هذا النص كما هو للرد.",
        },
        kbPdf: {
          label: "مستند المبنى",
          hint: "ارفع دليل المبنى بصيغة PDF أو Word ‏(.docx). سيقرأ الوكيل محتواه للرد.",
        },
        description: {
          label: "معلومات عامة",
          placeholder: "كيفية عمل التدفئة والتكييف، الأجهزة، ضبط المناخ، خصوصيات المبنى…",
          hint: "السياق الأساسي الذي سيستخدمه الوكيل في كل رد.",
        },
        wifiName: {
          label: "اسم شبكة الواي فاي",
          placeholder: "MyWifi_5G",
        },
        wifiPassword: {
          label: "كلمة مرور الواي فاي",
        },
        parkingInfo: {
          label: "موقف السيارات",
          placeholder: "موقف مجاني عند الباب / موقف مدفوع على بُعد 100 متر / لا يوجد موقف…",
        },
        amenities: {
          label: "المرافق والتجهيزات",
          placeholder: "مطبخ مجهّز، غسالة، مجفّف، تكييف، مصعد، سرير أطفال، مناشف…",
        },
        houseRules: {
          label: "قواعد المنزل",
          placeholder: "ممنوع التدخين، ممنوع الحفلات، الحيوانات الأليفة غير مسموحة، ساعات الهدوء 22:00–08:00…",
        },
        localRecommendations: {
          label: "توصيات المنطقة",
          placeholder: "مطاعم، متاجر، مواصلات، أماكن للزيارة قريبة…",
        },
        faqs: {
          label: "الأسئلة الشائعة",
          hint: "أزواج من سؤال وجواب. يمكنك إرفاق صور أو مقاطع فيديو بكل منها.",
        },
        links: {
          label: "روابط ومستندات",
          itemPlaceholder: "‎https://… (دليل المنزل، الدليل، الخريطة)",
          hint: "مصادر خارجية يمكن للوكيل الرجوع إليها.",
        },
        sendAmenityPhotos: {
          label: "إرسال صور التجهيزات ووسائل الراحة",
          hint: "إذا سأل الضيف عن وسيلة راحة لها صور، يجيبه الوكيل ويرسلها إليه. وإن لم تكن لها صور، يجيب بالنص فقط.",
        },
        customInstructions: {
          label: "تعليمات مخصّصة",
          placeholder: "قواعد محددة للنبرة أو المحتوى. مثال: اعرض دائماً المغادرة المتأخرة إذا سُئل عن المغادرة.",
        },
        forbiddenTopics: {
          label: "مواضيع أو إجراءات ممنوعة",
          placeholder: "مثال: لا تمنح خصومات، لا تؤكّد تغيير التواريخ دون موافقة، لا تُفصح عن بيانات نزلاء آخرين.",
        },
        escalationRules: {
          label: "متى يُحوّل إلى شخص بشري",
          placeholder: "مثال: عند وجود عطل أو شكوى جدية أو طلب استرداد، حوّل إلى المضيف.",
        },
        fallbackMessage: {
          label: "رسالة عند عدم معرفة الإجابة",
          placeholder: "لا تتوفّر لديّ هذه المعلومة الآن، لكنني سأبلغ المضيف وسنردّ عليك فوراً 🙌",
        },
        humanContact: {
          label: "جهة اتصال المضيف",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "ساعات الدعم البشري",
          placeholder: "الإثنين–الأحد 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "تسجيل الوصول",
      enableLabel: "إدارة تسجيل الوصول تلقائياً",
    },
    newBookings: {
      title: "الحجوزات الجديدة والعملاء المحتملون",
      subtitle: "يتولى الوكيل الرد على العملاء المحتملين الجدد (من يراسلون لأول مرة ويرغبون في الحجز أو لديهم استفسارات) ويرسل إليهم رابط الحجز المباشر لإتمام الحجز عبر الويب. هذا إعداد على مستوى الحساب: ينطبق على جميع مبانيك.",
      enableLabel: "الرد على العملاء المحتملين وطلبات الحجز",
      sections: {
        businessIdentity: {
          label: "هوية النشاط التجاري",
          hint: "الاسم الذي يُعرّف به الوكيل عن نفسه أمام من لم يحجز بعد.",
        },
        newLeads: {
          label: "عملاء محتملون جدد · أول تواصل",
          hint: "كيف يتعامل مع من يراسل لأول مرة مهتماً ولم يحجز بعد.",
        },
        bookingLink: {
          label: "رابط الحجز",
        },
      },
      fields: {
        businessName: {
          label: "الاسم التجاري",
          placeholder: "مثال: Hostel Elios، Apartamentos del Puerto، Grupo Ámbar…",
          hint: "عندما يسأل شخص بلا حجز عن هويتك، يردّ الوكيل «أنا مساعد [هذا الاسم]». إذا تركته فارغاً يُعرّف عن نفسه بشكل عام، دون ذكر النشاط التجاري.",
        },
        leadWelcomeMessage: {
          label: "رسالة ترحيب بعميل محتمل جديد",
          placeholder: "مرحباً! 👋 أنا مساعد المبنى. هل تبحث عن تواريخ لعطلة قصيرة أم لديك استفسار؟ يسعدني مساعدتك 😊",
          hint: "تحية أول تواصل عندما يراسل أحدهم لأول مرة. لا تتكرر في الرسائل التالية.",
        },
        leadWelcomeVerbatim: {
          label: "إرسال التحية كما هي (دون تعديلها)",
          hint: "مُفعّل: يستخدم الوكيل رسالتك حرفياً في أول تواصل. مُعطّل: يكيّفها حسب نبرة المحادثة.",
        },
        answerKbForLeads: {
          label: "الرد على الاستفسارات حتى قبل الحجز",
          hint: "يجيب الوكيل عن أسئلتهم العامة باستخدام قاعدة المعرفة —حتى وإن لم يكونوا نزلاء بعد— بالإضافة إلى إمكانية إرسال رابط الحجز.",
        },
        proactiveOffer: {
          label: "اقتراح الحجز بشكل استباقي",
          hint: "حتى لو سأل العميل المحتمل عن أمور أخرى، يشجّعه الوكيل على الحجز ويرسل له الرابط في الوقت المناسب، دون إلحاح.",
        },
        offerMessage: {
          label: "رسالة عند عرض الحجز",
          placeholder: "بالتأكيد! يمكنك الحجز مباشرة من هنا 👇 سأرسل لك الرابط لاختيار التواريخ.",
          hint: "النبرة التي يستخدمها الوكيل عند عرض الحجز. يضيف الوكيل الرابط تلقائياً.",
        },
      },
    },
    earlyAccess: {
      title: "إدارة أوقات الوصول",
      subtitle: "يدير الوكيل طلبات الوصول المبكّر: يسجّل وقت الوصول الذي يطلبه النزيل ويتعامل معه وفق قواعدك.",
      enableLabel: "إدارة أوقات الوصول",
      sections: {
        request: {
          label: "إدارة الطلب",
          hint: "كيف يردّ الوكيل حسب الوقت المطلوب. إذا عطّلتها، يبقى الطلب معلّقاً لتختار أنت (قبول / قبول وقت آخر / إعطاء أولوية / رفض).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "الرد بـ «حسب التوفّر» إذا كان قبل موعد تسجيل الوصول",
          hint: "يبلغ الوكيل النزيل بأنكم ستحاولون؛ يبقى معلّقاً بانتظار تأكيدك.",
        },
        autoApproveLate: {
          label: "القبول تلقائياً إذا كان بعد موعد تسجيل الوصول",
          hint: "الوصول ضمن الأوقات المعتادة يُؤكَّد تلقائياً.",
        },
      },
    },
    lateCheckout: {
      title: "المغادرة المتأخرة",
      subtitle: "يدير الوكيل طلبات المغادرة المتأخرة: يتحقق من الوقت، ويحسب السعر، ويسجّل الطلب.",
      enableLabel: "إدارة المغادرة المتأخرة",
      sections: {
        availability: {
          label: "التوفّر والمواعيد",
        },
        extraPrice: {
          label: "سعر الساعات الإضافية",
          hint: "يُحتسب فقط الجزء الذي يلي ساعات السماح.",
        },
        messages: {
          label: "الرسائل",
        },
      },
      fields: {
        standardCheckout: {
          label: "وقت المغادرة القياسي",
        },
        courtesyHours: {
          label: "ساعات السماح (مجاناً)",
          unit: "س",
          hint: "الساعات التي تلي المغادرة القياسية ولا تُحتسب أبداً.",
        },
        latestTime: {
          label: "أقصى وقت للمغادرة",
          hint: "الحد الأقصى المطلق. بعد فترة السماح، تُحتسب الساعات الإضافية.",
        },
        subjectToAvailability: {
          label: "حسب التوفّر",
          hint: "لا تُعرض الساعات الإضافية إلا إذا لم يصل حجز آخر في ذلك اليوم.",
        },
        autoConfirm: {
          label: "التأكيد تلقائياً إذا وافق النزيل",
          hint: "ينطبق فقط على الساعات المجانية.",
        },
        pricingModel: {
          label: "نموذج التسعير",
          options: {
            fixed: "سعر ثابت",
            perHour: "لكل ساعة إضافية",
          },
        },
        price: {
          label: "المبلغ",
          hint: "سعر ثابت، أو تعرفة لكل ساعة إضافية خارج فترة السماح.",
        },
        freeIfAvailable: {
          label: "مجاناً إذا لم يكن هناك وصول في اليوم نفسه",
          hint: "إذا كان ذلك اليوم شاغراً، لا تُحتسب الساعات الإضافية أيضاً.",
        },
        paymentMethods: {
          label: "طرق دفع الساعات الإضافية",
          options: {
            online: "الدفع عبر الإنترنت (Stripe) — يرسل الوكيل رابطاً",
            cash: "نقداً عند المغادرة",
          },
          hint: "يمكنك عرض واحدة أو كلتيهما. سيوضّح الوكيل ذلك للنزيل.",
        },
        offerMessage: {
          label: "رسالة العرض",
          placeholder: "هل تحتاج مزيداً من الوقت؟ نوفّر لك المغادرة حتى الساعة 13:00.",
        },
        confirmationMessage: {
          label: "رسالة التأكيد",
          placeholder: "تم! تم تأكيد مغادرتك المتأخرة. استمتع بتلك الساعات الإضافية 🙌",
        },
      },
    },
    invoicing: {
      title: "إصدار الفواتير",
      subtitle: "يرسل الوكيل إلى النزيل رابطاً لاستكمال بياناته الضريبية وتنزيل فاتورته الإلكترونية، باستخدام جهة إصدار الفواتير المرتبطة بهذا الإعلان.",
      enableLabel: "إدارة طلبات الفواتير",
      sections: {
        whenSend: {
          label: "متى يُرسَل رابط الفاتورة؟",
          hint: "اختر كيف يصل الرابط إلى النزيل. تظهر أدناه خيارات الوضع الذي تختاره.",
        },
        requirements: {
          label: "شروط إرسالها فوراً",
          hint: "لا يسلّم الوكيل الرابط إلا للنزلاء الذين أتمّوا تسجيل الوصول ودفعوا قيمة الحجز بالكامل؛ وبمجرد استكمال بياناتهم تُصدَر الفاتورة وتُنزَّل فوراً. في حجوزات منصات الحجز (Booking/Airbnb) لا يمكن استلام الفاتورة إلا بعد بدء الخدمة (بدء الإقامة) واكتمال الدفع.",
        },
        manualReview: {
          label: "مراجعة يدوية",
          hint: "يُسجَّل طلب النزيل فقط ويبقى معلّقاً في «فواتير بانتظار الإرسال» لتصدرها أنت يدوياً. لا تُنشأ أي فاتورة تلقائياً، ولا يهم متى يطلبها أو ما إذا كان الحجز مدفوعاً (أنت من يراجعها).",
        },
        fiscalData: {
          label: "البيانات الضريبية لجهة الإصدار",
          hint: "البيانات الضريبية (الاسم القانوني، الرقم الضريبي، السلسلة، ضريبة القيمة المضافة، Verifactu) لا تُضبط هنا: تُؤخذ من جهة إصدار الفواتير المرتبطة بهذا الإعلان في حسابي ← الفوترة الإلكترونية.",
        },
        sendToGuest: {
          label: "الإرسال إلى النزيل",
        },
      },
      modes: {
        after_checkout: {
          label: "فقط عند الطلب",
          desc: "يردّ كونسيرج الذكاء الاصطناعي عندما يطلب النزيل فاتورته.",
        },
        always_after_checkout: {
          label: "دائماً، عند انتهاء الإقامة",
          desc: "لكل من أتمّ تسجيل الوصول، سواء طلبها أم لا. موصى به.",
        },
      },
      cards: {
        on_request: {
          label: "فور طلبها",
          desc: "يصله الرابط في الحال، إذا استوفى الشروط.",
        },
        after_checkout: {
          label: "عند انتهاء إقامته",
          desc: "يُحفظ الطلب ويصله الرابط بعد المغادرة.",
        },
        manual: {
          label: "تسجيلها فقط",
          desc: "تبقى معلّقة وتُصدرها أنت يدوياً.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "إصدار الفاتورة حتى لو لم يملأ النموذج",
          hint: "تُصدَر ببيانات تسجيل وصوله ويُرسَل إليه ملف PDF عبر البريد الإلكتروني وواتساب. لا يمكن تعديل الفاتورة بعد إصدارها.",
        },
        autoIssueAfterHours: {
          label: "مدة الانتظار قبل إصدارها",
          options: {
            h24: "بعد 24 ساعة من إرسال الرابط",
            h48: "بعد 48 ساعة من إرسال الرابط",
            h72: "بعد 72 ساعة من إرسال الرابط",
          },
        },
        manualSendLink: {
          label: "إرسال الرابط إلى النزيل لاستكمال بياناته الضريبية",
          hint: "إذا فعّلته، يرسل الوكيل الرابط ليقدّم النزيل بياناته مسبقاً. تُصدَر الفاتورة يدوياً على أي حال.",
        },
        sendToGuest: {
          label: "إرسال الرابط إلى النزيل عبر",
          options: {
            email: "البريد الإلكتروني",
            whatsapp: "واتساب",
          },
        },
      },
    },
    extendStay: {
      title: "تمديد الإقامة",
      subtitle: "يدير الوكيل طلبات إضافة ليالٍ: يتحقق من التوفّر، ويحسب السعر، ويسجّل الطلب.",
      enableLabel: "السماح بطلبات تمديد الإقامة",
      sections: {
        availability: {
          label: "التوفّر",
          hint: "يُحدَّد الحد الأقصى لعدد الليالي تلقائياً حسب الحجز التالي في التقويم.",
        },
        price: {
          label: "السعر",
        },
        messages: {
          label: "الرسائل",
        },
      },
      fields: {
        autoConfirm: {
          label: "تمديد الحجز تلقائياً عند التأكيد",
          hint: "إذا عطّلته، يبقى طلباً لتوافق عليه أنت.",
        },
        useListingRate: {
          label: "استخدام تعرفة الليلة الخاصة بالإعلان",
          hint: "يحسب التعرفة انطلاقاً من سعر الحجز.",
        },
        pricePerNight: {
          label: "سعر الليلة الإضافية",
          hint: "فقط إذا لم تستخدم تعرفة الإعلان.",
        },
        paymentMethods: {
          label: "طرق دفع الليالي الإضافية",
          options: {
            online: "الدفع عبر الإنترنت (Stripe) — يرسل الوكيل رابطاً",
            cash: "نقداً",
          },
        },
        offerMessage: {
          label: "رسالة العرض",
          placeholder: "هل تريد البقاء مدة أطول؟ يمكنني إضافة ليالٍ إلى حجزك حسب التوفّر.",
        },
        confirmationMessage: {
          label: "رسالة التأكيد",
          placeholder: "رائع! سجّلت الليالي الإضافية. سنؤكّد بمجرد اكتمال الدفع 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "بدون تكلفة",
      subjectToAvailability: " حسب التوفّر.",
    },
    default: "مرحباً! كيف يمكنني مساعدتك؟ 😊",
    knowledge: {
      guestWifi: "ما كلمة مرور الواي فاي؟ 📶",
      wifiAnswer: "بالتأكيد! شبكة الواي فاي هي *{name}* وكلمة المرور هي *{pass}*. استمتع! 😊",
      wifiNameFallback: "الخاصة بالمبنى",
      wifiPassFallback: "••••••",
      genericAnswer: "بالتأكيد! سأرسل لك الآن كل ما تحتاجه من معلومات عن المبنى 😊",
    },
    checkin: {
      propFallback: "tu alojamiento",
      welcome: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{prop}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Elige tu idioma · Choose your language",
      langEs: "Español",
      langEn: "English",
      linkMsg: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "بالتأكيد! 😊 يمكنك الحجز مباشرة من هنا. سأرسل لك الرابط لاختيار التواريخ:",
      whoAsk: "مع من أتحدث؟",
      whoAnswer: "مرحباً! أنا مساعد {biz} 😊 كيف يمكنني مساعدتك؟",
      guestGreeting: "مرحباً! هل لديكم أي شيء متاح لعطلة نهاية الأسبوع؟ 😊",
      howBook: "رائع، كيف أحجز؟",
      linkLine: "{offer}\n\n🔗 احجز من هنا: {link}",
    },
    earlyAccess: {
      guestAsk: "هل يمكنني الدخول مبكّراً؟ سأصل حوالي الساعة 12 🙏",
      tentativeReply: "أخذنا علماً بوصولك المبكّر الساعة 12:00. سنبذل قصارى جهدنا لتجهيزه، لكن ذلك يعتمد على مغادرة النزيل السابق والتنظيف. سنبلغك فور توفّره 🙏",
      confirmedReply: "سجّلنا وصولك المبكّر الساعة 12:00. سنؤكّد لك قريباً 🙏",
    },
    lateCheckout: {
      courtesyPart: "لديك {hours} ساعة سماح مجانية بعد {time}. ",
      costPart: "المغادرة حتى {time} بتكلفة {price}{perHour}.",
      perHourSuffix: " لكل ساعة إضافية",
      payBoth: " يمكنك الدفع عبر الإنترنت أو نقداً عند المغادرة.",
      payCash: " الدفع نقداً عند المغادرة.",
      guestAsk: "هل يمكنني المغادرة في وقت متأخر غداً؟ 😅",
      guestConfirm: "حسناً، أؤكّد 👍",
      cashExtra: " (أو نقداً عند المغادرة)",
      confirmPayDefault: "تم! للتأكيد، أكمِل الدفع{extra}:",
      payLabel: "ادفع {price}",
      confirmCashDefault: "تم! تم تأكيد مغادرتك. دفع مبلغ {price} يكون نقداً عند المغادرة. 😊",
    },
    invoicing: {
      guestAsk: "هل يمكنك إرسال الفاتورة لي؟ 🧾",
      linkMsg: "مرحباً! 👋\n\nإليك رابطك لإنشاء فاتورتك الإلكترونية وتنزيلها:\n{link}\n\nيمكنك العودة إلى هذا الرابط متى احتجت للوصول إليها.",
      thanks: "شكراً على إقامتك! 🙌 إذا احتجت فاتورتك، إليك الرابط 👇",
      autoIssueNote: "_(بعد {hours} ساعة، إذا لم يستكمل بياناته)_\n\nأصدرنا فاتورتك ببيانات تسجيل وصولك وأرسلناها إليك عبر البريد الإلكتروني. 📩",
      manualLinkMsg: "مرحباً! 👋\n\nإليك الرابط لاستكمال بياناتك الضريبية:\n{link}\n\nسنراجع طلبك ونصدر الفاتورة يدوياً. 😊",
      manualRegistered: "مرحباً! 👋 سجّلت طلب فاتورتك. سنراجعه ونصدره يدوياً في أقرب وقت ممكن. شكراً! 😊",
    },
    extendStay: {
      guestAsk: "هل يمكنني البقاء ليلة إضافية؟ 🌙",
      guestConfirm: "نعم، ليلة إضافية 👍",
      rateListing: "بتعرفة حجزك",
      ratePerNight: "مقابل {price}/الليلة",
      nightSingular: "ليلة",
      nightPlural: "ليالٍ",
      offerDefault: "بالتأكيد! يمكنني إضافة حتى {max} {nights} {rate}.{avail}",
      cashExtra: " (أو نقداً)",
      confirmPayDefault: "ممتاز! لتأكيد الليلة الإضافية، أكمِل الدفع{extra}:",
      payLabel: "ادفع مقابل الليلة الإضافية",
      confirmCashDefault: "ممتاز! سجّلت الليلة الإضافية. الدفع نقداً وسيؤكّد المضيف التمديد. 😊",
    },
    general: {
      guestAsk: "مرحباً! مع من أتحدث؟",
      whoWithName: "أنا {name}، مساعدك",
      whoNoName: "أنا مساعدك",
      answer: "مرحباً! {who} في الاستقبال. كيف يمكنني مساعدتك؟{emo}",
    },
  },
  nationalities: {
    auto: "تلقائي (حسب النزيل)",
    latam: "أمريكا اللاتينية (محايد)",
    countries: {
      ES: "إسبانيا",
      MX: "المكسيك",
      CO: "كولومبيا",
      AR: "الأرجنتين",
      CL: "تشيلي",
      PE: "بيرو",
      VE: "فنزويلا",
      EC: "الإكوادور",
      UY: "أوروغواي",
      PY: "باراغواي",
      BO: "بوليفيا",
      CR: "كوستاريكا",
      PA: "بنما",
      GT: "غواتيمالا",
      DO: "جمهورية الدومينيكان",
      PR: "بورتوريكو",
      CU: "كوبا",
      FR: "فرنسا",
      PT: "البرتغال",
      BR: "البرازيل",
      US: "الولايات المتحدة",
      IT: "إيطاليا",
      BE: "بلجيكا",
      MA: "المغرب",
      NL: "هولندا",
      CH: "سويسرا",
    },
    styles: {
      latamNeutral: "إسبانية لاتينية محايدة",
      esES: "قياسي — تخاطب غير رسمي (tú) · «vale»، «genial»",
      esMX: "قياسي — «con gusto»، «estacionamiento»",
      esCO: "عام — تخاطب رسمي (usted) · «con gusto»",
      esCOpaisa: "لهجة بايسا (ميديلين) — «pues»، «hágale»",
      esCOcosta: "لهجة الساحل (الكاريبي) — «¡ajá!»، «quihubo»",
      esCOrolo: "لهجة رولو (بوغوتا) — تخاطب رسمي (usted) · «a la orden»",
      esCOvalle: "لهجة فايي (كالي) — voseo · «vea pues»",
      esCOsantander: "لهجة سانتاندير — مباشر · «de una»",
      esAR: "voseo — «dale»، «buenísimo»",
      esCL: "لبق — «estacionamiento»",
      esPE: "تخاطب رسمي (usted) — أندي محايد",
      esVE: "تخاطب غير رسمي (tú) — «chévere»",
      esEC: "تخاطب رسمي (usted) — أندي محايد",
      esUY: "voseo — «ta»، «bo»",
      esPY: "voseo — لبق",
      esBO: "تخاطب رسمي (usted) — أندي",
      esCR: "voseo — «pura vida»",
      esPA: "تخاطب غير رسمي (tú) — كاريبي",
      esGT: "تخاطب رسمي (usted) — لبق",
      esDO: "تخاطب غير رسمي (tú) — كاريبي",
      esPR: "تخاطب غير رسمي (tú) — كاريبي",
      esCU: "تخاطب غير رسمي (tú) — كاريبي",
      frFR: "الفرنسية (فرنسا)",
      ptPT: "البرتغالية (البرتغال)",
      ptBR: "البرتغالية (البرازيل)",
      enUS: "الإنجليزية الأمريكية",
      itIT: "الإيطالية (إيطاليا)",
      frBE: "الفرنسية (بلجيكا)",
      nlBE: "الهولندية / الفلمنكية (بلجيكا)",
      arMA: "العربية (المغرب)",
      frMA: "الفرنسية (المغرب)",
      nlNL: "الهولندية",
      deCH: "الألمانية السويسرية",
      frCH: "الفرنسية السويسرية",
      itCH: "الإيطالية السويسرية",
    },
  },
};
